import Link from "next/link";
import { useTranslations } from "next-intl";

import { twMerge } from "@/utils/twMerge";

import type { MessageKeys, NestedKeyOf } from "next-intl";

export type SuggestionIntlName = MessageKeys<IntlMessages, NestedKeyOf<IntlMessages>>;

export const footerLinks: { intlName: SuggestionIntlName; href: string }[] = [
  {
    intlName: "sidebarFooter.about",
    href: "/about",
  },
  {
    intlName: "sidebarFooter.whatIsCorca",
    href: "/doc/45KghvqDJatmDv7T_MGhq",
  },
  {
    intlName: "sidebarFooter.faq",
    href: "/doc/i5kqPoOExKpasVr9YDcRG",
  },
  {
    intlName: "sidebarFooter.documentation",
    href: "/doc/jy-_zc_6jXLO3QxfPHlL6/quick-start",
  },
  {
    intlName: "sidebarFooter.tos",
    href: "/tos",
  },
  {
    intlName: "sidebarFooter.privacy",
    href: "/privacy",
  },
];

export const socialLinks: {
  intlName: SuggestionIntlName;
  href: string;
  icon: string;
  iconDark?: string;
}[] = [
  {
    intlName: "sidebarFooter.twitter",
    href: "https://x.com/corca_math",
    icon: "/social/twitter.png",
    iconDark: "/social/twitter-dark.png",
  },
  {
    intlName: "sidebarFooter.discord",
    href: "https://discord.com/invite/zjGKuvY6uA",
    icon: "/social/discord.png",
  },
  {
    intlName: "sidebarFooter.bluesky",
    href: "https://bsky.app/profile/corca.io",
    icon: "/social/bluesky.png",
  },
];

function FooterLink({
  title,
  href,
  lastItem = false,
}: {
  title: string;
  href: string;
  lastItem?: boolean;
}) {
  return (
    <>
      <Link href={href} className={twMerge("hover:underline", "sm:hover:no-underline")}>
        {title}
      </Link>
      {!lastItem && <span> · </span>}
    </>
  );
}

export function SidebarFooter({ className }: { className?: string }) {
  const t = useTranslations();
  return (
    <div
      className={twMerge(
        "text-xs text-secondary tracking-tight mb-[8px] ml-[5px] leading-[1.4]",
        "sm:text-[16px]",
        className,
      )}
    >
      <p className={twMerge("mb-2.5")}>
        {footerLinks.map((item, index, array) => {
          return (
            <FooterLink
              key={item.intlName}
              title={t(item.intlName)}
              href={item.href}
              lastItem={index === array.length - 1}
            />
          );
        })}
      </p>
      <p className={twMerge("mb-2.5")}>
        {socialLinks.map((item, index, array) => {
          return (
            <FooterLink
              key={item.intlName}
              title={t(item.intlName)}
              href={item.href}
              lastItem={index === array.length - 1}
            />
          );
        })}
      </p>
      <p className="text-document-text">
        {t("sidebarFooter.copyright", { year: new Date().getFullYear() })}
      </p>
    </div>
  );
}
